module.exports = __webpack_public_path__ + "img/faro-room-2.91560416.jpg";